module.exports = __webpack_public_path__ + "static/media/kapp.b43abb23.mp3";